import { render, staticRenderFns } from "./RoleActionDelete.vue?vue&type=template&id=4beb4ffb&"
import script from "./RoleActionDelete.vue?vue&type=script&lang=ts&"
export * from "./RoleActionDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports